/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can';
import template from './comparison-summary-tabs.stache';
import _ from 'lodash';
import {
    MAKE_CUT_PROBABILITY,
    TOP_10_PROBABILITY,
    WIN_PROBABILITY,
} from 'components/probability/types';

export const COMPARISON_SUMMARY_TABS = [
    {
        title: 'Win Probability',
        value: WIN_PROBABILITY,
    },
    {
        title: 'Make Cut',
        value: MAKE_CUT_PROBABILITY,
    },
    {
        title: 'Top 10',
        value: TOP_10_PROBABILITY,
    },
];

can.Component.extend({
    tag: 'comparison-summary-tabs',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            probabilityType: {
                type: 'string',
            },
            tabs: {
                type: 'array',
                value: COMPARISON_SUMMARY_TABS,
            },
        },
        changeTab(event) {
            const tab = _.find(
                this.attr('tabs'),
                ({ value }) => value === event.payload.value,
            );

            this.dispatch({
                type: 'tabChange',
                tab,
            });
        },
    },
});
